export const getters = {
  getChatBubbles: _state => _state.chatBubbles,

  getUiFlags: _state => _state.uiFlags,
};
